module.exports = __webpack_public_path__ + "static/media/027.f4b00426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/027.jpg
// module id = 534
// module chunks = 0